
import { Injectable, Inject } from '@angular/core';
import{BasePolicyPremiumBreakupDO} from './basePolicyPremiumBreakup.model';

export class GroupPolicyPremiumBreakupDO extends BasePolicyPremiumBreakupDO  {
         public  id:number = null;
}

